// production
const config = {
  baseUrl: "https://app.adminhero.co",
  apiBaseUrl: "https://api.adminhero.co",
  apiKey: "fBrL6zASe3j7ESZJ3MaebqzerPRcOhXK",
  cookieDomain: ".adminhero.co",
  namespace: "adminhero"
};

if (window.location.hostname === "localhost") {
  // development
  config.baseUrl = `http://${window.location.host}`;
  config.apiBaseUrl = "http://localhost:3000";
  config.apiKey = "wzaILy2jtT1p2Nwz9PHRodiIMUnR19ua";
  config.cookieDomain = "localhost";
} else if (window.location.hostname === "app-staging.adminhero.co") {
  // staging
  config.baseUrl = "https://app-staging.adminhero.co";
  config.apiBaseUrl = "https://api-staging.adminhero.co";
  config.apiKey = "svFrFO10H4yyMUhewrssvsTudh3jWscJ";
  config.cookieDomain = ".adminhero.co";
}

export default config;
